export default __webpack_public_path__ + "static/media/counter_green.f9e66377.svg";